<script>
import _ from "lodash";
import { getSummaryAPI } from "./archetype";
import { notify } from "@/utils.js";
import Axios from "axios";
import imgPortal from '../elements/img-portal.vue';

export default {
	components: { imgPortal },
	name: "MonederoUserOverview",
	props: {
		userId: {
			type: [String, Number],
			required: true,
		},
	},
	data: () => {
		return {
			summary: {
				usuario: {
					id_pk: null,
					nombre: null,
					apellidos: null,
					imagen: null,
					correo_electronico: null,
					usuario: null,
					vigenciaVIP: null,
				},
				consumoEasyLunch: 0,
				monederoActivo: 0,
				adeudo: 0,
				monedero: 0,
				datosTransferencia: null,
				pagosSinRevisar: 0,
			},
			isLoading: false,
		};
	},
	methods: {
		async loadUp() {
			this.isLoading = true;
			try {
				let response = await Axios.get(getSummaryAPI(this.userId));
				if (_.isObjectLike(response)) {
					this.summary = response.data;
				}
			} catch (e) {
				notify(e);
			}
			this.isLoading = false;
		},
	},
	beforeMount() {
		this.loadUp();
	},
};
</script>

<template>
	<div class="monederoUserOverview">
		<div v-if="isLoading" class="text-center p-3">
			<strong>Cargando...</strong>
		</div>
		<b-row v-else align-v="center" no-gutters>
            <b-col cols="auto">
                <img-portal class="monedero-img" :src="summary.usuario.imagen" :allowZoom="true" />
            </b-col>
            <b-col>
                <div class="nombres">
                    {{summary.usuario.nombre}}
                    {{summary.usuario.apellidos}}
                </div>
                <div class="email">
                    {{summary.usuario.correo_electronico}}
                </div>
                <div class="pagos">
                    <div class="adeudo" v-if="summary.adeudo">Adeudo: <strong>{{summary.adeudo | currency}}</strong></div>
                    <div class="monedero" v-else>Monedero:  <strong>{{summary.monedero | currency}}</strong></div>
                    <div class="pagosSinRevisar" v-if="summary.pagosSinRevisar">Pagos sin revisar <strong>{{summary.pagosSinRevisar}}</strong></div>
                </div>
            </b-col>
		</b-row>
	</div>
</template>

<style lang="less">
.monederoUserOverview {
    background: #e4e7ea;
    .adeudo {
        color: var(--danger);
    }
    .nombres {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 1.618em;
    }
    .email {
        font-size: calc(1em / 1.618);
    }
    .monedero-img {
        margin: 1em;
        width: 6em;
        height: 6em;
    }
}
</style>